import React from 'react';
import {
  AccoladeBadge,
  AccoladeBadgeSize,
} from 'js/components/AccoladeBadge/AccoladeBadge';
import { TooltipPosition } from 'js/components/generic/Tooltip';
import styles from './Eyecatcher.module.css';

export interface Accolade {
  tooltipText?: string;
  imageUri: string;
}

export type EyecatcherType = string | Accolade;

interface Props {
  data: EyecatcherType;
}

export class Eyecatcher extends React.PureComponent<Props> {
  public render(): React.ReactNode {
    if (typeof this.props.data === 'string') {
      return (
        <div className={styles.bannerContainer}>
          <div className={styles.banner}>{this.props.data}</div>
        </div>
      );
    }
    return (
      <AccoladeBadge
        positioningClass={styles.badgePosition}
        size={AccoladeBadgeSize.Small}
        imageUri={this.props.data.imageUri}
        tooltipText={this.props.data.tooltipText}
        tooltipPosition={TooltipPosition.Bottom}
      />
    );
  }
}
